import { render, staticRenderFns } from "./TheSimpleCourse.vue?vue&type=template&id=45985808&scoped=true&"
import script from "./TheSimpleCourse.vue?vue&type=script&lang=js&"
export * from "./TheSimpleCourse.vue?vue&type=script&lang=js&"
import style0 from "./TheSimpleCourse.vue?vue&type=style&index=0&id=45985808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45985808",
  null
  
)

export default component.exports